var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_646","data-name":"Path 646","d":"M353.99,1771.787l-5.054,2.657.965-5.628-4.089-3.986,5.651-.821,2.527-5.121,2.527,5.121,5.651.821-4.089,3.986.965,5.628Z","transform":"translate(-345.812 -1758.888)","fill":"#fff"}));
}

Star.defaultProps = {"width":"16.356","height":"15.556","viewBox":"0 0 16.356 15.556"};

module.exports = Star;

Star.default = Star;
